import { Component } from 'react';
import styled, { css } from 'styled-components';
import { ID_NEW } from '../../../../../../domain/model/category/ICategoryRepository';
import TabItemText from '../../../common/components/js/modules/TabItemText';
import TabItemBlock from '../../../common/components/js/modules/TabItemBlock';
import TabList from '../../../common/components/js/modules/TabList';

export interface ITabCategory {
  name: string;
  id: string;
  isCurrent: boolean;
}

interface IProps {
  currentRegionId?: string;
  currentPrefectureId?: string;
  regions: ITabCategory[];
  prefecturesInRegion: ITabCategory[];
  changeTab: (regionId: string, prefectureId: string) => void;
  changeParentTab: (regionId: string) => void;
  reflectStorage: () => void;
}

const Nav = styled.nav<{ $hasFeedChildTab: boolean }>`
  border-top: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};

  ${({ $hasFeedChildTab }) =>
    $hasFeedChildTab
      ? css`
          /* サブカテがある場合はlv2 */
          border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
        `
      : css`
          /* 全国タブなど、サブカテがない時はlv1 */
          border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
        `}
`;
export default class NewsFeedLocalTab extends Component<IProps> {
  /**
   *
   */
  public componentDidMount() {
    this.props.reflectStorage();
  }

  /**
   *
   */
  public render() {
    // 親要素
    const items = this.props.regions.map((region, index) => (
      <TabItemText
        name={region.name}
        isCurrent={region.isCurrent}
        isFontSizeLarge={false}
        isSpaced={false}
        dataClParams={
          region.id === ID_NEW ? `_cl_vmodule:stnv_loc;_cl_link:n_loc;` : `_cl_vmodule:stnv_loc;_cl_link:${region.id};`
        }
        key={region.name}
        onclick={() => {
          // 次に表示する都道府県がstoreにあれば取得する
          this.props.changeParentTab(region.id);
        }}
      />
    ));

    // 子要素
    const childItems = this.props.prefecturesInRegion.map((prefecture, index) => (
      <TabItemBlock
        name={prefecture.name}
        isCurrent={prefecture.isCurrent}
        dataClParams={`_cl_vmodule:stnv_loc;_cl_link:${prefecture.id};`}
        key={prefecture.name}
        onclick={() => {
          if (this.props.currentRegionId) {
            this.props.changeTab(this.props.currentRegionId, prefecture.id);
          }
        }}
      />
    ));

    // 子要素が存在するときのみ 子タブ要素を表示する
    const hasFeedChildTab = childItems.length > 1;
    const feedChildTab = hasFeedChildTab ? (
      <nav>
        <TabList tabType="block">{childItems}</TabList>
      </nav>
    ) : null;

    return (
      <Nav $hasFeedChildTab={hasFeedChildTab}>
        <TabList tabType="text">{items}</TabList>
        {feedChildTab}
      </Nav>
    );
  }
}
